module.exports = __webpack_public_path__ + "img/megan-600x600.a2e9f250.png";